import { render } from "./LightBox.vue?vue&type=template&id=488d0dce&scoped=true"
import script from "./LightBox.vue?vue&type=script&lang=js"
export * from "./LightBox.vue?vue&type=script&lang=js"

import "./LightBox.vue?vue&type=style&index=0&id=488d0dce&scoped=true&lang=css"

import exportComponent from "C:\\Data\\lightsOut\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488d0dce"]])

export default __exports__